import API from "./baseApi";

const getAllTickets = (payload) => {
    return API.get("/bookings/allTickets", payload);
  };

const getTicketById = (id,payload) => {
    return API.get("/bookings/"+id, payload);
  };


export default {getAllTickets,getTicketById}


